import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {customerActions} from "./customerSlice";
import {customerApi} from "~/api";

function* fetchCustomerList(action) {
	try {
		const response = yield call(customerApi.gets, action.payload);
		yield put(customerActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch customer list', error);
		yield put(customerActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(customerActions.setFilter(action.payload));
}

export default function* customerSaga() {
	yield takeLatest(customerActions.fetchData.type, fetchCustomerList);
	yield debounce(500, customerActions.setFilterWithDebounce.type, handleSearchDebounce)
}